<template>
  <div
    class="home-search is-relative hero is-primary-green is-large"
    :style="{
      'background-image': `url(${require(`@/assets/images/${image}`)})`
    }"
  >
    <section>
      <div class="hero-body">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-three-quarters is-full-mobile back-opacity">
              <h1
                v-if="titleType == 'h1'"
                class="title has-text-centered has-text-weight-bold"
              >
                {{ title }}
              </h1>
              <h2
                v-if="titleType == 'h2'"
                class="title has-text-centered has-text-weight-bold"
              >
                {{ title }}
              </h2>
              <div class="columns">
                <div class="column is-full-mobile is-10 is-flex margin-list">
                  <div class="search">
                    <div>
                      <div class="top-section">
                        <b-field class="search-field">
                          <b-input
                            v-model="searchText"
                            placeholder="Prueba ingresando aquí la dirección que buscas"
                            icon="search"
                            icon-clickable
                            @keypress.native.enter="searchPorperties"
                          >
                          </b-input>
                        </b-field>

                        <b-field class="selling-type">
                          <b-radio-button
                            v-for="(adTypeOption, index) in adTypeOptions"
                            :key="`ad-type-${index}`"
                            v-model="selectedAdTypes"
                            :native-value="adTypeOption"
                            type="is-secondary"
                          >
                            <span>{{ adTypeOption.name }}</span>
                          </b-radio-button>
                        </b-field>
                      </div>

                      <div class="bottom-section">
                        <b-field class="building-type">
                          <b-select
                            placeholder="Tipo de propiedad"
                            expanded
                            v-model="selectedPropertyTypes"
                            :loading="loadingSelectOptions"
                          >
                            <option
                              v-for="option in propertyTypeOptions"
                              :value="option"
                              :key="option.id"
                            >
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-field>

                        <b-field class="building-type">
                          <b-select
                            placeholder="Zona"
                            expanded
                            v-model="selectedZone"
                            :loading="loadingSelectOptions"
                            class="place-color "
                          >
                            <option
                              v-for="option in zoneTypeOptions"
                              :value="option"
                              :key="option.id"
                            >
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-field>

                        <b-field class="building-type">
                          <b-select
                            placeholder="Num. Hab"
                            expanded
                            v-model="selectedRoomNumber"
                            class="place-color numhab"
                          >
                            <option
                              v-for="(option, index) in roomNumberOptions"
                              :key="`room-${index}`"
                              :value="option"
                            >
                              {{ option.description }}
                            </option>
                          </b-select>
                        </b-field>

                        <b-field>
                          <b-input
                            min="0"
                            placeholder="Precio desde"
                            type="number"
                            v-model="price.from"
                            class="place-color"
                          >
                          </b-input>
                        </b-field>

                        <b-field class="m-r-0">
                          <b-input
                            min="0"
                            placeholder="Hasta"
                            type="number"
                            v-model="price.to"
                          >
                          </b-input>
                        </b-field>
                      </div>
                      <div class="action-section m-t-xs">
                        <div class="columns">
                          <div class="column is-2 is-offset-10">
                            <b-button
                              :disabled="disabled"
                              type="is-primary"
                              class="has-text-weight-bold"
                              expanded
                              @click="searchPorperties('list')"
                            >
                              Buscar
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full-mobile is-2 is-flex margin-map">
                  <div class="search map">
                    <img src="@/assets/icons/boton_mapa.png" alt="icon mapa" />
                    <b-button
                      :disabled="disabled"
                      type="is-primary"
                      class="has-text-weight-bold"
                      expanded
                      @click="searchPorperties('map')"
                    >
                      Buscar Mapa
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="search">
      
    </section> -->
  </div>
</template>

<script>
const defaultSelectOption = { id: null, name: "Todos" };
const defaultSelectOptionProperty = { id: null, name: "Cualquiera" };
const defaultSelectOptionZone = { id: null, name: "Zona" };

export default {
  name: "PropertySearch",

  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    fetchFilters: {
      type: Boolean,
      default: false
    },
    titleType: {
      type: String,
      default: "h1"
    }
  },

  data() {
    return {
      price: { from: null, to: null },
      roomNumberOptions: [
        { from: 1, to: 1, description: "1" },
        { from: 2, to: 2, description: "2" },
        { from: 3, to: 3, description: "3" },
        { from: 4, to: 4, description: "4" },
        { from: 5, to: 5, description: "5" }
      ],
      searchText: "",
      selectedAdTypes: defaultSelectOption,
      selectedPropertyTypes: defaultSelectOptionProperty,
      selectedRoomNumber: null,
      loadingSelectOptions: false,
      selectedZone: defaultSelectOptionZone
    };
  },

  computed: {
    adTypeOptions() {
      return []
        .concat(this.$store.state.search.adTypes)
        .concat(defaultSelectOption);
    },
    disabled() {
      return this.price.from < 0 || this.price.to < 0;
    },
    propertyTypeOptions() {
      return [defaultSelectOptionProperty].concat(
        this.$store.state.search.propertyTypes
      );
    },
    zoneTypeOptions() {
      return [defaultSelectOptionZone].concat(this.$store.state.search.zones);
    }
  },

  beforeMount() {
    if (this.fetchFilters) {
      this.$store.dispatch("search/getSearchFilterOptions");
    }
  },

  methods: {
    removeSelectedProp(arr) {
      return arr.map(el => {
        delete el.selected;
        return el;
      });
    },

    searchPorperties(searchType) {
      if (this.selectedAdTypes && this.selectedAdTypes.id !== null) {
        this.$store.commit("filter/update_adtype", this.selectedAdTypes.id);
      }

      if (
        this.selectedPropertyTypes &&
        this.selectedPropertyTypes.id !== null
      ) {
        this.$store.commit(
          "filter/update_propertytypes",
          this.selectedPropertyTypes
        );
      }

      if (this.selectedZone && this.selectedZone.id !== null) {
        delete this.selectedZone.count;
        this.$store.commit("filter/update_zones", this.selectedZone);
      }

      if (this.selectedRoomNumber) {
        this.$store.commit("filter/update_rooms", this.selectedRoomNumber.to);
      }

      this.$store.commit("filter/update_pricesfrom", this.price.from || 0);
      this.$store.commit("filter/update_pricesto", this.price.to || undefined);

      this.$store.commit(
        "filter/update_searchtext",
        this.searchText || undefined
      );

      this.$router
        .push({ name: "properties", query: { type: searchType } })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss">
$input-placeholder-color: red;

.home-search {
  background-color: $grey;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.home-search .search {
  padding: 1em;
  background-color: $white;
  width: 100%;
}

.home-search .search > div {
  background-color: $white;
}

.home-search .search .top-section {
  margin-bottom: 1em;
}

.home-search .selling-type {
  .control {
    width: 50%;
  }
}

.home-search .back-opacity {
  background-color: rgba(26, 66, 117, 0.5);
}

.home-search .place-color .select select option:first {
  color: red;
}

.home-search .place-color select::placeholder,
.home-search .place-color input.input::placeholder {
  color: red;
  opacity: 0.5; /* Firefox */
}

.m-r-0 {
  margin-right: 0;
}

.margin-list {
  padding-right: 0.75rem;
  padding-bottom: 0.25rem;
}

.margin-map {
  padding-left: 0.75rem;
  padding-top: 0.25rem;
}

.search.map {
  padding: 0.5rem;
  text-align: center;

  img {
    height: 90px;
    width: 40%;
  }
}

.home-search .numhab {
  min-width: 60px;
}

@media only screen and (min-width: 769px) {
  .home-search {
    .container {
      margin-top: -150px;
    }
  }

  .home-search .search .top-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;

    .search-field {
      flex-grow: 1;
      margin-right: 1em;
    }
  }

  .home-search .search .bottom-section {
    display: flex;

    .field {
      margin-bottom: 0px;
      margin-right: 1em;
      flex-grow: 1;
    }

    .button {
      width: auto;
    }

    .select {
      width: auto;
    }

    .m-r-0 {
      margin-right: 0;
    }
  }
  .margin-list {
    padding-right: 0.25rem;
    padding-bottom: 0.75rem;
  }

  .margin-map {
    padding-left: 0.25rem;
    padding-top: 0.75rem;
  }

  .search.map img {
    width: 100%;
  }
}
</style>
